import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { of } from "rxjs"; // Para retornar uma resposta mockada
import { AssinaturaService } from "../modules/shared/services/assinatura.service";

@Injectable()
export class ApiBlockAssinaturaInterceptor implements HttpInterceptor {
  public planoStatus = false;

  constructor(private assinaturaService: AssinaturaService) {
    this.assinaturaService.getplanoplanoAtual().subscribe((plano) => {
      if (!plano?.produto) {
        this.planoStatus = true;
      } else {
        this.planoStatus = false;
      }
    });
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      req.url.indexOf("api.supervademecum.com.br") === -1 &&
      req.url.indexOf("localhost") === -1
    ) {
      return next.handle(req);
    }

    if (
      req.url.includes("assinatura/novo") ||
      req.url.includes("assinatura/alterar") ||
      req.url.includes("auth/login") ||
      req.url.includes("auth/logoff") ||
      req.url.includes("auth/refresh-token") ||
      req.url.includes("assinatura/meu-plano") ||
      req.url.includes("viacep.com.br/ws")||
      req.url.includes("assets/ui/icons")
    ) {
      return next.handle(req);
    }

    // Bloquear chamadas para a API
    if (this.planoStatus) {
      return of(); // Retorna um Observable vazio
    }

    // Caso contrário, deixa a requisição passar
    return next.handle(req);
  }
}
